import React from "react"

import Popover from "../../gd-components/gd-popover/popover"
import AddViewContent from "./add-view-content"
import {AddView_Group} from "./@types"
import {PopoverAttachmentType} from "../../gd-components/gd-popover/@const";

type Props = {
    viewsStructure      : AddView_Group[]
    selectedGroupId?    : ID

    attachment?         : string
    targetAttachment?   : string
    attachmentType?     : PopoverAttachmentType
    offset?             : string
    targetOffset?       : string

    height?             : number

    getTargetFunc       : func
    hidePopover         : func
}

// const debug = "AddViewPopover"
const debug = false

export default function AddViewPopover(props:Props) {

    const onClickOutside = (e: React.SyntheticEvent) => {
        const ignoreClick = !!gd.utils.Dom.findNodeByClassName(e.target, ["ui5-popover-menu"])

        debug && console.log(debug, 'onClickOutside', ignoreClick, e.target)

        if (!ignoreClick) {
            props.hidePopover()
        }
    }

    const popoverStyle: any = {}
    if (props.height) {
        popoverStyle.height = props.height
    }

    return (
        <Popover popoverClass           = "ui-menu-add-view-popover"
                 popoverContentStyle    = {popoverStyle}
                 constraints            = {[{
                     to         : 'window',
                     attachment : 'together',
                     pin        : true
                 }]}
                 attachment             = {props.attachment}
                 targetAttachment       = {props.targetAttachment}
                 attachmentType         = {props.attachmentType}
                 offset                 = {props.offset}
                 targetOffset           = {props.targetOffset}
                 arrowsVersion          = {2}
                 getTargetFunc          = {props.getTargetFunc}
                 onClickOutside         = {onClickOutside}>

            <AddViewContent viewsStructure  = {props.viewsStructure}
                            selectedGroupId = {props.selectedGroupId}
                            hidePopover     = {props.hidePopover}/>
        </Popover>
    )
}

AddViewPopover.defaultProps = {
    attachment          : 'top left',
    targetAttachment    : 'top right',
    attachmentType      : PopoverAttachmentType.VERTICAL,
    offset              : '0 0'
}